/**
 * SecureEmbed Energy Portal - Tier Definitions
 */

export interface TierDefinition {
  level: number;
  label: string;
  shortLabel: string;
  color: string;
  bgColor: string;
  description: string;
}

export const TIERS: Record<number, TierDefinition> = {
  1: {
    level: 1,
    label: 'Tier 1',
    shortLabel: 'T1',
    color: 'text-blue-600',
    bgColor: 'bg-blue-100',
    description: 'Analytics & Search',
  },
  1.5: {
    level: 1.5,
    label: 'Tier 1a',
    shortLabel: 'T1a',
    color: 'text-purple-600',
    bgColor: 'bg-purple-100',
    description: 'Insights & Provenance',
  },
  2: {
    level: 2,
    label: 'Tier 2',
    shortLabel: 'T2',
    color: 'text-amber-600',
    bgColor: 'bg-amber-100',
    description: 'Reports & Export',
  },
  3: {
    level: 3,
    label: 'Tier 3',
    shortLabel: 'T3',
    color: 'text-red-600',
    bgColor: 'bg-red-100',
    description: 'Real-time Streaming',
  },
};

export const TIER_ORDER = [1, 1.5, 2, 3];

export function getTierLabel(tier: number): string {
  return TIERS[tier]?.label || `Tier ${tier}`;
}

export function getNextTier(current: number): number | null {
  const idx = TIER_ORDER.indexOf(current);
  if (idx === -1 || idx >= TIER_ORDER.length - 1) return null;
  return TIER_ORDER[idx + 1];
}

export function parseTierFromCognito(tierValue: string | undefined): number {
  if (!tierValue) return 3; // Default to highest for admin/demo
  const val = tierValue.toLowerCase().trim();
  if (val === '1a' || val === '1.5' || val === 'tier1a') return 1.5;
  const num = parseFloat(val);
  if (!isNaN(num) && TIERS[num]) return num;
  return 3;
}
